import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainTab", "mainPanel", "categoryTab", "categoryPanel"]
  static values = {
    active: { type: String, default: "settings" },
    activeCategory: { type: String, default: "pro" },
  }

  switchTab(event) {
    this.activeValue = event.currentTarget.dataset.tab
  }

  switchCategory(event) {
    this.activeCategoryValue = event.currentTarget.dataset.category
  }

  activeValueChanged(value) {
    this.#toggle(this.mainTabTargets, this.mainPanelTargets, "tab", value, "is-active")
  }

  activeCategoryValueChanged(value) {
    this.#toggle(this.categoryTabTargets, this.categoryPanelTargets, "category", value, "is-active")
  }

  #toggle(tabs, panels, attr, active, activeClass) {
    tabs.forEach(el => el.classList.toggle(activeClass, el.dataset[attr] === active))
    panels.forEach(el => el.classList.toggle("hidden", el.dataset[attr] !== active))
  }
}
